<div class="tutorial">
  @for (tutorial of tutorials; track tutorial.title; let i = $index) {
    <div class="tutorial__wrapper" tabindex="0">
      @if (i > 0) {
        <i aria-hidden="true" class="material-icons">navigate_next</i>
      }
      <portal-tutorial-svg class="tutorial__wrapper__image" [id]="tutorial.image" />
      <div [attr.aria-label]="tutorial.aria?.label | translate">
        @if (tutorial.title) {
          <h2 class="mat-h5">{{ tutorial.title | translate }}</h2>
        }
        <mat-chip-option aria-hidden="true" class="tutorial__wrapper__chip--bold">
          {{ i + 1 }}
        </mat-chip-option>
        @if (tutorial.description) {
          <p class="translation-text">
            {{ tutorial.description | translate }}
          </p>
        }
      </div>
    </div>
  }
</div>
